const KIDS = 'Kids';

export const isKidsVideo = (videoProperties) => {
    return videoProperties !== undefined && videoProperties.indexOf(KIDS) !== -1;
};

export const isAuthenticated = () => {
    return CBS.Registry.user_auth ?? false;
};
